<c-row>

    <c-col xs="12">
        <c-card class="mb-12">

            <c-card-header ngPreserveWhitespaces>
                <strong>Reversa Liquidación</strong> <small>Captura</small>
            </c-card-header>
            <c-card-body xs="12">
                <form [formGroup]="guardarFG">
                <c-row>
                    <c-col [md]="3"></c-col>
                    <c-col [md]="6">
                        <label> <b>Semana de Liquidación</b> </label>
                        <c-row class="forBor1">
                            <c-col [md]="6">
                                <label cLabel for="idPartner">Ejercicio</label>
                                <input id="id" cFormControl formControlName="idEjercicio"
                                    [value]="panelInfo.currentDate | date: 'yyyy'">
                            </c-col>
                            <c-col [md]="6">
                                <label cLabel for="idPartner">Semana</label>
                                <input id="id" cFormControl formControlName="idSemana"
                                [value]="panelInfo.week">
                            </c-col>
                        </c-row>
                    </c-col>
                    <c-col [md]="3"></c-col>
                    
                </c-row>
            </form>
                <c-col [md]="12">
                    <button class="tmBA" cButton (click)="onReversaClick()">Reversa</button>
                </c-col>
            </c-card-body>
        </c-card>
    </c-col>
</c-row>